/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    cov: {
        id: 'quoteandbind.PSWSpaAndWellLinedirectives.templates.Information.Coverages',
        defaultMessage: 'Coverages'
    },
    form:{
        id: 'quoteandbind.PSWSpaAndWellLinedirectives.templates.Information.Endorsements',
        defaultMessage: 'Endorsements'
    },
    totalInsValue: {
        id: 'quoteandbind.PSWSpaAndWellLinedirectives.templates.Information.Total Insured Value',
        defaultMessage: 'Total Insured Value : '
    }

});